import axios from "axios";

const pickupPointsService = {
  async fetch() {
    return axios.get('/order/api/points');
  },
  async fetchPointsByCity(city) {
    return axios.post('/cart/api/pointsByCity', {
      city
    })
  },
};

export default pickupPointsService;